<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    <v-card class="box" fixed>
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Send SMS to students</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-col cols="6" sm="6" md="6">
        <v-icon color="error">*</v-icon>
        <v-autocomplete
          color="#0F2027"
          dense
          rounded
          required
          v-model="template"
          return-object
          :items="sms_template_array"
          item-text="template_name"
          label="SMS Template"
          outlined
          @change="get_template(template)"
          persistent-hint
        />
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <!-- <v-card class="box"> -->
        <v-textarea
          outlined
          color="#0F2027"
          v-model="preapproved_sms"
          label="SMS Template"
        ></v-textarea>
        <!-- </v-card> -->
      </v-col>

      <v-row dense justify="center">
        <!-- <v-list-item>
                        <v-list-item-content>
                            <div class="text-overline mb-4">Pre-Approved SMS Template</div>
                            <v-list-item-subtitle v-html="preapproved_sms"> </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item> -->

        <v-col cols="12" sm="4" md="4">
          <!-- <v-card class="mx-auto" max-width="344">
                            <v-card-text style="color: red;">*Upload CSV file only!</v-card-text>
                            <v-card-actions> -->
          <v-file-input
            color="#0F2027"
            outlined
            rounded
            dense
            :required="true"
            prepend-icon="mdi-attachment"
            label="Choose File For Import"
            show-size
            v-model="file"
            name="doc"
            @change="validateFile"
          ></v-file-input>
          <!-- </v-card-actions>
                        </v-card> -->
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
          <a
            href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/BulkSMS_CSVFormat.csv"
          >
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              outlined
              class="ma-2 white--text downbtn button"
              @click="loader = 'loading3'"
            >
              Download CSV format
              <v-icon right dark>mdi-cloud-download</v-icon>
            </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <!-- <v-divider vertical></v-divider>
                    <v-col cols="12" sm="4" md="4"> -->
        <!-- <v-card class="mx-auto" max-width="344">
                            <v-card-text> -->
        <!-- <div>Principal</div> -->
        <!-- <p class="text-h4 text--primary">+91 1231231231</p> -->
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            color="#0F2027"
            clearable
            dense
            v-model="principalno"
            label=" Principal Contanct No."
            placeholder="Enter Principal Contanct No."
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            color="#0F2027"
            clearable
            dense
            v-model="coordinatorno"
            label="Coordinator Contanct No."
            placeholder="Enter Coordinator Contanct No."
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            color="#0F2027"
            clearable
            dense
            v-model="teacherno"
            label="Teacher Contanct No."
            placeholder="Enter Teacher Contanct No."
            outlined
          ></v-text-field>
        </v-col>
        <!-- <div>Coordinator</div>
                <p class="text-h4 text--primary">+91 1231231231</p>
                <div>Teacher</div>
                <p class="text-h4 text--primary">+91 1231231231</p> -->
        <p style="font-style: italic">*Above personnel will also receive SMS</p>
        <!-- </v-card-text>
                        </v-card> -->
        <!-- </v-col> -->
      </v-row>
      <v-row class="justify-center">
        <v-btn
          class="button"
          :disabled="disabled"
          :loading="fetch_loader"
          @click="sendsms"
          >Send SMS <v-icon>mdi-cellphone-message</v-icon></v-btn
        >
      </v-row>
    </v-card>


    <v-card class="box" fixed>
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>View SMS Logs</strong>
        </v-toolbar-title>
      </v-toolbar>
       <v-row class="justify-center">
      <v-col cols="12" sm="3" md="3">
        <v-icon color="error">*</v-icon>
        <v-autocomplete
          color="#0F2027"
          dense
          rounded
          required
          v-model="ay"
          :items="ay_list"
          item-text="ay"
          item-value="id"
          label="Academic Year"
          outlined
          persistent-hint
        />
      </v-col>
       </v-row>
      <v-row class="justify-center">
        <v-btn
          class="button"
          :loading="fetch_loader"
          @click="fetch()"
          >Fetch </v-btn
        >
      </v-row>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="failsmsdailog" width="700px">
      <v-card>
        <v-card-title>
          <span
            >Following students have not received SMS, please try again!</span
          >
        </v-card-title>
        <v-card-text>
          <v-simple-table height="300px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Contact No.</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in failed_sms_student_list" :key="item">
                  <td>{{ item }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-row class="justify-center">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="failsmsdailog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
      <v-dialog v-model="show_history" style="margin-top: 10%" fullscreen hide-overlay
                transition="dialog-top-transition">
                <v-card class="mx-auto">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Communication History</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="show_history = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <br />
                    <v-card-text>
                         <v-card class="box">
                            <v-data-table dense class="elevation-1 mytable" :headers="headers" :search="search" :items="comm_history" :items-per-page="-1" fixed-header>
               
                <template v-slot:[`item.history`]="{ item }">
               <div v-if="item.contact_nos  !='-'">
                <v-avatar size="35">
                  <v-icon
                    class="mr-4 v-icon-size"
                    color="red"
                    @click="displayNumbers(item)"
                    >mdi-eye</v-icon
                  >
                </v-avatar>
            </div>
            <div v-else>--</div>
          </template>
                </v-data-table>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-dialog>

           <v-dialog v-model="show_contacts" persistent max-width="1200px" transition="dialog-bottom-transition">
                <v-card class="mx-auto">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Communication History</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="show_contacts = false;show_history=true"><v-icon>mdi-close</v-icon>Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <br />
                    <!-- {{contacts}} -->
                    <v-card-text>
                <v-card class="box">
                   <v-simple-table dense class="elevation-1 table-container">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                               <th>Sr No</th>
                                                <th>Number</th>
                                            </tr>
                                        </thead>
                                         <tr v-for="(item,index) in contacts" :key="item">
                                                <td>{{ index+1}}</td>
                                                <td>{{ item }}</td>
                                         </tr>
                                    </template>
                   </v-simple-table>
                    <!-- <v-data-table dense class="elevation-1 mytable" :headers="headers_1" :search="search" :items="contacts" :items-per-page="-1" fixed-header>
                </v-data-table> -->
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-dialog>     
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data() {
    return {
      search:"",
      contacts:[],show_contacts:false,
      overlay: true,
      failed_sms_student_list: [],
      sms_template_array: [],
      template: null,
      teacherno: null,
      coordinatorno: null,
      principalno: null,
      disabled: true,
      file: null,
      snackbar_msg: "",
      snackbar: "",
      color: "",
      preapproved_sms: "",
      fetch_loader: false,
      headers3: [
        {
          text: "Sr. No.",
          value: "srno",
        },
        {
          text: "Contact No",
          value: "student_name",
        },
      ],
      headers:[
         {text: "Sr. No.",value: "count"},
         {text: "Body",value: "body"},
         {text: "From.",value: "sentfrom"},
        //  {text: "To",value: "sentto"},
         {text: "To",value: "history"},
         {text: "Date",value: "sentdate"}, 
      ],
      headers_1:[
         {text: "SR No",value: "srno"},
         {text: "Number",value: "no"},
      ],
      failsmsdailog: false,
      ay_list:[],ay:"",overlay:false,comm_history:[],show_history:false,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    displayNumbers(item){
      this.contacts=[]
      this.contacts=item.contact_nos
      this.show_contacts=true
    },
    fetch(){
        const data = {
              ay:this.ay
          };
          this.overlay = true;
          axios
              .post("/CommunicationType/getCommunicationHistory", data)
              .then((res) => {
              if (res.data.flag == "YES") {
                  // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
                  this.comm_history=res.data.comm_history
                  this.show_history=true
              } else if (res.data.flag == "No") {
                  this.showSnackbar("red", res.data.snackbar);
              } else {
                  this.showSnackbar("red", res.data.snackbar);
                  sessionStorage.setItem("error-trace", res.data.error_trace);
              }
              this.overlay = false;
              })
              .catch((error) => {
              this.onerror(error);

              this.overlay = false;
              })
              .finally(() => {
              this.overlay = false;
              });
    },
    onLoad() {
      this.overlay = true;
      this.fetch_loader = true;
      axios
        .post("/CommunicationType/sendSmsGCSwithCSVDataHome")
        .then((res) => {
          this.principalno = res.data.contact_1;
          this.coordinatorno = res.data.contact_2;
          this.sms_template_array = res.data.sms_template_array;
          this.ay_list = res.data.ay_list;
          this.ay = res.data.cay;
          this.overlay = false;
          this.fetch_loader = false;
        })
        .catch((error) => {
          this.overlay = false;
          this.fetch_loader = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.fetch_loader = false;
          this.overlay = false;
        });
    },
    validateFile() {
      let file_name = this.file.name;
      let ext = file_name.split(".").pop();
      if (ext != "csv") {
        this.showSnackbar("#b71c1c", "Please upload only CSV file!");
        return;
      } else {
        this.disabled = false;
      }
    },
    sendsms() {
      this.overlay = true;
      // console.log("inside sendsms ");
      if (this.file == null) {
        this.overlay = false;
        this.showSnackbar("#b71c1c", "Please upload a file!");
        return;
      }
      if (this.coordinatorno != null) {
        if (this.coordinatorno.length != 10) {
          this.overlay = false;
          this.showSnackbar(
            "#b71c1c",
            "Coordinator's Contact No. is not valid!"
          );
          return;
        }
      }
      if (this.principalno != null) {
        if (this.principalno.length != 10) {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Principal's Contact No. is not valid!");
          return;
        }
      }
      if (this.teacherno != null) {
        if (this.teacherno.length != 10) {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Teacher's Contact No. is not valid!");
          return;
        }
      }
      if (this.template == null) {
        this.showSnackbar("#b71c1c", "Please select Template!");
        return;
      }
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("coordinator_no", this.coordinatorno);
      formData.append("principal_no", this.principalno);
      formData.append("teacher_no", this.teacherno);
      formData.append("message_body", this.preapproved_sms);
      formData.append("template_id", this.template.id);
      // console.log("formData");
      // console.log(formData);
      axios
        .post("/CommunicationType/send_sms_new", formData)
        .then((res) => {
          this.overlay = false;
          // console.log("res.data");
          // console.log(res.data);
          if (res.data.wrong_list.length > 0) {
            for (var i = 0; i < res.data.wrong_list.length; i++) {
              this.failed_sms_student_list = res.data.wrong_list;
            }
            this.showSnackbar("#b71c1c", "Incorrenct Contact No."); // show snackbar
            this.failsmsdailog = true;
          } else if (res.data.code == "SUCCESS") {
            this.showSnackbar(
              "success",
              "SMS has been sent successfully to selected students..."
            );
            this.showSnackbar(
              "success",
              "Message Id: "+res.data.message_id
            );
          } else if (res.data.code == "cred_error") {
            this.showSnackbar("#b71c1c", "Credentials Not Found Error!");
          } else if (res.data.code == "template_error") {
            this.showSnackbar("#b71c1c", "Template Not Found Error!");
          } else {
            this.showSnackbar(
              "#b71c1c",
              "Something went wrong, please try again later!"
            );
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    get_template(template) {
      this.preapproved_sms = template.template_text;
    },
  },
};
</script>

<style></style>
